import { createStore } from '@'

export const $codeSuggestions = createStore('tour-mapping:codeSuggestions')
export const $airportSuggestions = createStore('tour-mapping:airportSuggestions')
